export const state = () => ({
	publicFolder: null,
});

export const mutations = {
	publicFolder(state, payload) {
		state.publicFolder = payload;
	},
};

export const getters = {
	publicFolder: (state) => {
		return state.publicFolder;
	},
};
